<template>
  <div style="background:#fff; padding:20px;">
    <!-- 顶部搜索区 -->
    <div style="margin-bottom: 20px">
      <a-form layout="inline">
        <a-form-item label="申请类型">
          <a-select
            v-model="query.applyType"
            placeholder="全部"
            allow-clear
            style="width: 120px"
          >
            <a-select-option :value="1">商家</a-select-option>
            <a-select-option :value="2">师傅</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="审核状态">
          <a-select
            v-model="query.auditStatus"
            placeholder="全部"
            allow-clear
            style="width: 120px"
          >
            <a-select-option :value="0">待审核</a-select-option>
            <a-select-option :value="1">已通过</a-select-option>
            <a-select-option :value="2">已拒绝</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="公司/姓名">
          <a-input
            v-model="query.realName"
            placeholder="请输入公司或姓名"
            allow-clear
            style="width: 160px"
          />
        </a-form-item>
        <a-form-item>
          <a-button type="primary" icon="search" @click="handleSearch">查询</a-button>
          <a-button style="margin-left:10px" icon="reload" @click="handleReset">重置</a-button>
        </a-form-item>
      </a-form>
    </div>

    <!-- 列表 -->
    <a-table
      :columns="columns"
      :data-source="data"
      rowKey="id"
      :loading="loading"
      :pagination="pagination"
      @change="handleTableChange"
    >
      <span slot="applyType" slot-scope="text">
        <a-tag v-if="text === 1" color="blue">商家</a-tag>
        <a-tag v-else-if="text === 2" color="purple">师傅</a-tag>
        <span v-else>-</span>
      </span>

      <span slot="auditStatus" slot-scope="text">
        <a-tag v-if="text === 0" color="orange">待审核</a-tag>
        <a-tag v-else-if="text === 1" color="green">已通过</a-tag>
        <a-tag v-else-if="text === 2" color="red">已拒绝</a-tag>
        <span v-else>-</span>
      </span>

      <span slot="action" slot-scope="text, record">
        <a style="margin-right: 8px;" @click="handleShowDetail(record)">查看详情</a>
        <template v-if="record.auditStatus === 0">
          <a-popconfirm title="确定通过该申请?" @confirm="handleApprove(record.id)">
            <a style="color: #1890ff">通过</a>
          </a-popconfirm>
          <a-divider type="vertical" />
          <a style="color: red" @click="handleOpenReject(record)">拒绝</a>
        </template>
        <span v-else style="color: #999; margin-left: 8px;">已处理</span>
      </span>
    </a-table>

    <!-- 拒绝原因弹窗(原因可选, 不再强制必填) -->
    <a-modal
      v-model="rejectVisible"
      title="审核拒绝"
      :confirm-loading="rejectSubmitting"
      @ok="handleSubmitReject"
      @cancel="handleCloseReject"
    >
      <a-form-model
        ref="rejectForm"
        :model="rejectForm"
        :label-col="{ span: 5 }"
        :wrapper-col="{ span: 16 }"
      >
        <a-form-model-item label="拒绝原因">
          <a-textarea
            v-model="rejectForm.failReason"
            :rows="4"
            :max-length="200"
            placeholder="可选，最多 200 字。留空时师傅端将看到通用提示文案"
          />
          <div style="text-align:right; color:#999; font-size:12px;">
            {{ (rejectForm.failReason || '').length }} / 200
          </div>
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <!-- 图片预览弹窗 -->
    <a-modal
      v-model="previewVisible"
      :footer="null"
      destroyOnClose
      @cancel="previewVisible = false"
      width="600px"
    >
      <div style="text-align: center; padding: 20px 0;">
        <img :src="previewImage" style="max-width: 100%; max-height: 500px; object-fit: contain; border-radius: 4px;" />
      </div>
    </a-modal>

    <!-- 申请详情弹窗 -->
    <a-modal
      v-model="detailVisible"
      title="入驻申请详情"
      :footer="null"
      width="900px"
    >
      <a-descriptions bordered :column="2" v-if="detailRecord">
        <a-descriptions-item label="申请 ID">
          {{ detailRecord.id }}
        </a-descriptions-item>
        <a-descriptions-item label="用户 ID">
          {{ detailRecord.userId }}
        </a-descriptions-item>
        <a-descriptions-item label="申请类型">
          <a-tag v-if="detailRecord.applyType === 1" color="blue">商家</a-tag>
          <a-tag v-else-if="detailRecord.applyType === 2" color="purple">师傅</a-tag>
          <span v-else>-</span>
        </a-descriptions-item>
        <a-descriptions-item label="审核状态">
          <a-tag v-if="detailRecord.auditStatus === 0" color="orange">待审核</a-tag>
          <a-tag v-else-if="detailRecord.auditStatus === 1" color="green">已通过</a-tag>
          <a-tag v-else-if="detailRecord.auditStatus === 2" color="red">已拒绝</a-tag>
          <span v-else>-</span>
        </a-descriptions-item>
        <a-descriptions-item :label="detailRecord.applyType === 1 ? '公司名称' : '真实姓名'" :span="2">
          {{ detailRecord.realName }}
        </a-descriptions-item>
        <a-descriptions-item label="联系电话">
          {{ detailRecord.contactPhone }}
        </a-descriptions-item>
        <a-descriptions-item label="身份证号" v-if="detailRecord.applyType === 2">
          {{ detailRecord.idCard }}
        </a-descriptions-item>
        <a-descriptions-item label="提交时间">
          {{ detailRecord.createdAt }}
        </a-descriptions-item>
        <a-descriptions-item label="审核时间">
          {{ detailRecord.auditAt || '-' }}
        </a-descriptions-item>
        <a-descriptions-item label="拒绝原因" :span="2" v-if="detailRecord.auditStatus === 2">
          <span style="color: red;">{{ detailRecord.failReason || '未填写拒绝原因' }}</span>
        </a-descriptions-item>
        <a-descriptions-item label="资质/身份证照片" :span="2">
          <div v-if="detailRecord.qualificationImages">
            <!-- 小程序本地临时路径特殊警告提示 -->
            <div 
              v-if="isLocalTempPath(detailRecord.qualificationImages)"
              style="background: #fffbe6; border: 1px solid #ffe58f; padding: 12px; border-radius: 4px; margin-bottom: 10px;"
            >
              <div style="color: #d46b08; font-weight: bold; margin-bottom: 4px;">
                ⚠️ 提示：提交的图片为小程序本地临时路径
              </div>
              <div style="font-size: 13px; color: #666; line-height: 1.6;">
                当前提交的图片路径为：
                <code style="background: #fafafa; padding: 2px 4px; border: 1px solid #e8e8e8; border-radius: 3px; word-break: break-all; display: block; margin-top: 4px;">
                  {{ detailRecord.qualificationImages }}
                </code>
                微信小程序的临时路径（<span style="color:#d4380d;">http://tmp/...</span>）仅在提交者手机本地有效，后台浏览器无法直接跨沙箱访问该本地缓存。
                生产环境接入 OSS 或上传服务器后即可正常显示大图。
              </div>
            </div>
            
            <!-- 图片展示 -->
            <div style="display: flex; gap: 16px; margin-top: 8px;">
              <div 
                v-for="(img, idx) in detailRecord.qualificationImages.split(',')" 
                :key="idx"
                style="text-align: center;"
              >
                <img 
                  :src="img" 
                  style="width: 220px; height: 140px; object-fit: contain; border: 1px solid #e8e8e8; border-radius: 4px; cursor: pointer; display: block;" 
                  @click="handlePreviewImage(img)"
                />
                <span style="font-size: 12px; color: #999; margin-top: 4px; display: inline-block;">
                  {{ idx === 0 ? '人像面 (正面)' : '国徽面 (反面)' }}
                </span>
              </div>
            </div>
          </div>
          <span v-else>未上传照片</span>
        </a-descriptions-item>
      </a-descriptions>
      
      <!-- 快捷审核动作 -->
      <div style="margin-top: 20px; text-align: right;" v-if="detailRecord && detailRecord.auditStatus === 0">
        <a-button type="danger" style="margin-right: 10px;" @click="handleOpenRejectFromDetail">拒绝</a-button>
        <a-popconfirm title="确定通过该申请?" @confirm="handleApproveFromDetail">
          <a-button type="primary">通过</a-button>
        </a-popconfirm>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { getAuditList, approveAudit, rejectAudit } from '@/api'

export default {
  data() {
    return {
      data: [],
      loading: false,
      // 搜索条件
      query: {
        applyType: undefined,
        auditStatus: undefined,
        realName: ''
      },
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0
      },
      // 拒绝弹窗
      rejectVisible: false,
      rejectSubmitting: false,
      rejectForm: {
        id: null,
        failReason: ''
      },
      // 大图预览
      previewVisible: false,
      previewImage: '',
      // 申请详情
      detailVisible: false,
      detailRecord: null,
      columns: [
        { title: 'ID', dataIndex: 'id', width: 80 },
        { title: '用户ID', dataIndex: 'userId', width: 100 },
        {
          title: '申请类型',
          dataIndex: 'applyType',
          width: 100,
          scopedSlots: { customRender: 'applyType' }
        },
        { title: '公司/姓名', dataIndex: 'realName' },
        { title: '身份证号', dataIndex: 'idCard' },
        { title: '联系电话', dataIndex: 'contactPhone' },
        {
          title: '审核状态',
          dataIndex: 'auditStatus',
          width: 100,
          scopedSlots: { customRender: 'auditStatus' }
        },
        { title: '拒绝原因', dataIndex: 'failReason' },
        { title: '提交时间', dataIndex: 'createdAt', width: 170 },
        { title: '审核时间', dataIndex: 'auditAt', width: 170 },
        {
          title: '操作',
          key: 'action',
          width: 180,
          scopedSlots: { customRender: 'action' }
        }
      ]
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    // 加载列表
    loadData() {
      this.loading = true
      const params = {
        page: this.pagination.current,
        pageSize: this.pagination.pageSize,
        applyType: this.query.applyType,
        auditStatus: this.query.auditStatus,
        realName: this.query.realName || undefined
      }
      getAuditList(params)
        .then(res => {
          const payload = (res && res.data) || {}
          if (payload.records) {
            this.data = payload.records
            this.pagination.total = payload.total || 0
          } else if (payload.list) {
            this.data = payload.list
            this.pagination.total = payload.total || 0
          } else if (Array.isArray(payload)) {
            this.data = payload
            this.pagination.total = payload.length
          } else {
            this.data = []
            this.pagination.total = 0
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 查询
    handleSearch() {
      this.pagination.current = 1
      this.loadData()
    },
    // 重置
    handleReset() {
      this.query = {
        applyType: undefined,
        auditStatus: undefined,
        realName: ''
      }
      this.pagination.current = 1
      this.loadData()
    },
    // 表格分页
    handleTableChange(pagination) {
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.loadData()
    },
    // 通过
    handleApprove(id) {
      approveAudit(id).then(() => {
        this.$message.success('审核通过成功')
        this.loadData()
      })
    },
    // 打开拒绝弹窗
    handleOpenReject(record) {
      this.rejectForm = {
        id: record.id,
        failReason: ''
      }
      this.rejectVisible = true
    },
    // 关闭拒绝弹窗
    handleCloseReject() {
      this.rejectVisible = false
      this.rejectForm = { id: null, failReason: '' }
    },
    // 提交拒绝(原因可选, 仅做长度上限校验)
    handleSubmitReject() {
      const reason = (this.rejectForm.failReason || '').trim()
      if (reason.length > 200) {
        this.$message.error('拒绝原因不能超过 200 字')
        return
      }
      this.rejectSubmitting = true
      rejectAudit(this.rejectForm.id, { failReason: reason })
        .then(() => {
          this.$message.success('已拒绝该申请')
          this.rejectVisible = false
          this.rejectForm = { id: null, failReason: '' }
          this.loadData()
        })
        .finally(() => {
          this.rejectSubmitting = false
        })
    },
    // 预览大图
    handlePreviewImage(img) {
      this.previewImage = img
      this.previewVisible = true
    },
    // 显示详情
    handleShowDetail(record) {
      this.detailRecord = record
      this.detailVisible = true
    },
    // 详情页快捷通过
    handleApproveFromDetail() {
      if (!this.detailRecord) return
      approveAudit(this.detailRecord.id).then(() => {
        this.$message.success('审核通过成功')
        this.detailVisible = false
        this.loadData()
      })
    },
    // 详情页快捷拒绝
    handleOpenRejectFromDetail() {
      if (!this.detailRecord) return
      this.handleOpenReject(this.detailRecord)
      this.detailVisible = false
    },
    // 判断是否为小程序本地临时路径
    isLocalTempPath(path) {
      if (!path) return false
      return path.includes('http://tmp') || path.includes('wxfile://')
    }
  }
}
</script>
